import api, { BASE_URL } from '@/lib/axios'

export interface LocalizedString {
    tr: string
    en?: string
    fr?: string
    es?: string
    ru?: string
    nl?: string
    ar?: string
}

export interface TeamMember {
    _id?: string
    name: string
    role: LocalizedString
    category: LocalizedString
    experience?: LocalizedString
    email?: string
    phone?: string
    imageUrl?: string
    orderIndex?: number
}

export interface TeamPage {
    _id?: string
    hero: {
        title: LocalizedString
        description: LocalizedString
    }
    stats: Array<{
        value: string
        label: LocalizedString
    }>
    members: TeamMember[]
    bottomContent?: {
        title: LocalizedString
        description: LocalizedString
    }
}

export const teamPageService = {
    getTeamPage: async () => {
        const res = await api.get<TeamPage>('/team-page')
        const data = res.data
        if (data.members) {
            data.members = data.members.map(m => ({
                ...m,
                imageUrl: m.imageUrl?.startsWith('/') ? `${BASE_URL}${m.imageUrl}` : m.imageUrl
            }))
        }
        return data
    },
    updateTeamPage: async (data: Partial<TeamPage>, translate: boolean = false) => {
        const res = await api.put<TeamPage>('/team-page', data, { params: { translate } })
        return res.data
    },
    uploadTeamPhoto: async (file: File) => {
        const formData = new FormData()
        formData.append('photo', file)
        const res = await api.post<{ photo: { url: string } }>('/upload/team-photo', formData)
        return {
            ...res.data,
            photo: {
                ...res.data.photo,
                url: res.data.photo.url?.startsWith('/') ? `${BASE_URL}${res.data.photo.url}` : res.data.photo.url
            }
        }
    }
}
